import CompactPill from "./examples/CompactPill.Example";
const CompactPillCode = require("!raw-loader!./examples/CompactPill.Example.tsx") as string;
import RegularPill from "./examples/RegularPill.Example";
const RegularPillCode = require("!raw-loader!./examples/RegularPill.Example.tsx") as string;
import LargePill from "./examples/LargePill.Example";
const LargePillCode = require("!raw-loader!./examples/LargePill.Example.tsx") as string;
import PillGroupExample from "./examples/PillGroup.Example";
const PillGroupExampleCode = require("!raw-loader!./examples/PillGroup.Example.tsx") as string;

export default [
    {
        title: "Compact pill",
        component: CompactPill,
        code: CompactPillCode
    },
    {
        title: "Regular pill",
        component: RegularPill,
        code: RegularPillCode
    },
    {
        title: "Large pill",
        component: LargePill,
        code: LargePillCode
    },
    {
        title: "Pill group overflow",
        component: PillGroupExample,
        code: PillGroupExampleCode
    }
];
